import React from "react";
import AButton from "../../../../views/pages/manage/common/form-fields-mui/AButton";
import { useNavigateToGivenPath } from "views/pages/manage/edpOps/studentDetails/paymentSummary/service";

const getMessageText = (
  chequeNos = [],
  psid,
  applicationId,
  isDiscontinued
) => {
  const statusText = isDiscontinued
    ? "the student is discontinued, and security will be adjusted in outstanding"
    : "the transfer request is approved";
  return `Cheque No. ${chequeNos.join(
    ", "
  )} is in Not Deposited status for PSID: ${psid} and Application ID: ${applicationId}. Please deposit the cheque before proceeding, else the cheques will be canceled once ${statusText}.`;
};

// show pending cheques component that will get cancelled on discontinuation or transfer request approval
const ShowPendingCheques = ({
  onProceed,
  chequeNos,
  psid,
  applicationId,
  isDiscontinued = false,
  businessAreaId,
  cashierOffice,
  hideModal,
}) => {
  // admin/cheque-management/receipts/DW005/DW005
  const onDeposit = () => {
    window.open(
      `/#/admin/cheque-management/receipts/${businessAreaId}/${cashierOffice}`,
      "_blank"
    );
  };



  return (
    <div>
      <div className="text-bold mb-2" style={{ lineHeight: "30px" }}>
        {getMessageText(chequeNos, psid, applicationId, isDiscontinued)}
      </div>

      <AButton
        className="button_remove_left_margin"
        variant="outline"
        onClick={onDeposit}
      >
        Deposit Cheque
      </AButton>
      <AButton variant="outline" onClick={onProceed}>
        Submit Request
      </AButton>
    </div>
  );
};

export default ShowPendingCheques;
